import * as React from "react";
const SvgFiRrCarJourney = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-car-journey_svg__a)">
      <path
        fill="#062147"
        d="M24 18c0 2.206-1.794 4-4 4h-5a1 1 0 1 1 0-2h5c1.103 0 2-.897 2-2s-.897-2-2-2h-7c-2.206 0-4-1.794-4-4s1.794-4 4-4h2a1 1 0 1 1 0 2h-2c-1.103 0-2 .897-2 2s.897 2 2 2h7c2.206 0 4 1.794 4 4m-12 2.5a1.5 1.5 0 0 1-1.5 1.5h-.525c.012.082.025.164.025.25a1.75 1.75 0 0 1-3.5 0c0-.086.013-.168.025-.25h-2.05c.012.082.025.164.025.25a1.75 1.75 0 0 1-3.5 0q.002-.17.033-.331A1.49 1.49 0 0 1 0 20.5V18c0-1.654 1.346-3 3-3h1.895c1.34 0 2.584.666 3.328 1.781L9.702 19h.798a1.5 1.5 0 0 1 1.5 1.5M2 19h5.298l-.74-1.109A2 2 0 0 0 4.894 17H2.999c-.551 0-1 .449-1 1zm17-9a1 1 0 0 0 1-1V5.25l3.565-1.885c.581-.399.581-1.329 0-1.729L20.752.377A4.3 4.3 0 0 0 19.001 0a1 1 0 0 0-1 1v8c0 .552.446 1 .999 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-car-journey_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCarJourney;
